export default {
  changeasset:
    "Das Asset wurde inzwischen von einem anderen Benutzer aktualisiert und Ihre Änderungen können nicht gespeichert werden. Bitte versuchen Sie es erneut.",
  general: "Allgemein",
  header: "Achtung",
  noDataAvailable: "Keine Daten verfügbar...",
};
